import React, { useCallback, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import Success from "../../shared/success"
import ROUTES from "../../services/routes"
import { IRedux } from "../../services/types"
import { setLoading } from "../../redux/loading"
import EmployeeApi from "../../services/api/Employee.api"
import UserEventApi from "../../services/api/UserEvent.api"
import useHistoryCustom from "../../hooks/useHistoryCustom"
import UserEventDayApi from "../../services/api/UserEventDay.api"

const Confirmation = () => {
  const history = useHistoryCustom()
  const dispatch = useDispatch()

  const event = useSelector((state: IRedux) => state.event)
  const { userId, companyId, daysId } = useSelector(
    (state: IRedux) => state.inscription
  )

  const registerUser = useCallback(async () => {
    dispatch(setLoading(true))
    if (userId && companyId) {
      await new UserEventApi().updateOrCreateOne(userId, {
        registeredFrom: "WEB"
      })
      const promises = [
        new EmployeeApi().createOne(userId, companyId),
        ...event.EventDays.map(ed => {
          const find =
            event.EventDays.length <= 1
              ? true
              : daysId.find(d => Number(d) === ed.id)
          return new UserEventDayApi(ed.id).updateOrCreateOne(userId, {
            registered: !!find,
            registeredAt: find ? new Date() : null
          })
        })
      ]
      const [employee] = await Promise.all(promises)
      await new UserEventApi().updateOrCreateOne(userId, {
        employeeId: employee.id
      })
    }
    dispatch(setLoading(false))
  }, [companyId, daysId, dispatch, event.EventDays, userId])

  useEffect(() => {
    registerUser()
  }, [companyId, registerUser, userId])

  return (
    <div>
      <Success message="L'utilisateur a bien été inscrit." isSuccess />
      <div className="buttons is-centered">
        <button
          type="button"
          className="button is-primary"
          onClick={() => {
            history.push(ROUTES.EVENTS_INSCRIPTION)
          }}
        >
          Inscrire une nouvelle personne
        </button>
        <button
          type="button"
          className="button is-dark"
          onClick={() => history.push(ROUTES.HOME)}
        >
          Retour à la liste des personnes inscrites
        </button>
      </div>
    </div>
  )
}

export default Confirmation
